import { createSlice } from "@reduxjs/toolkit";
import HomeAPIs from "api/Home/home";
import { requests } from 'api/index';
import URLS  from 'api/endPoints';


// Slice

const initiaPortfoliotate = {
 PREVIEWJOB:""
}

const slice = createSlice({
  name: "SinglePortfolio",
  initialState: {
    home: initiaPortfoliotate,
  },
  reducers: {
 
    getPreviewJob: (state, action) => {
      // console.log("KNOWPREVIEW REDUCER", action.payload)
      state.home.PREVIEWJOB = action.payload
    }
    
  },
});

export default slice.reducer;

// Actions

const { getPreviewJob } = slice.actions


export const getPreviewJobAction = (payload) => async (dispatch) => {
  
  try {
  
    let response = await requests.get(URLS.magUrl.portfolioPreview + payload.id)
    // console.log(response, "FROMAPI")
     await dispatch(getPreviewJob(response))

    return await returnCode(response)

  } catch (error) {

    return console.error(error.message)
    
  }
}



function returnCode(response) {
  if (response.ResponseCode == 100 || 200) {
    return response;
  } else if (response.ResponseCode == 103) {
    return 103;
  } else {
    return 101;
  }
}
